import ArticleCard from 'components/v2/molecules/article-card';
import type { ArticleType } from 'service/article';

export interface ArticleGridType {
  articles: ArticleType[];
}

const ArticleGrid = ({ articles }: { articles: ArticleType[] }) => {
  if (articles.length === 0) {
    return null;
  }

  return (
    <div className="mb-20 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {articles.map((article) => (
        <ArticleCard key={article.id} article={article} />
      ))}
    </div>
  );
};

export default ArticleGrid;
